const VIDEO_BASE = 'https://res.cloudinary.com/dp22pyubg/video/upload';

// Public ID from a Cloudinary video URL: everything after /upload/, minus the
// version and extension. Some IDs include a folder and some don't, so don't
// assume a fixed number of path segments.
const publicIdFrom = (url) => url.split('/upload/')[1].replace(/^v\d+\//, '').replace(/\.[a-z0-9]+$/i, '');

export const VideoPlayer = ({ image_url, width, height }) => {
    const publicId = publicIdFrom(image_url);

    return (
        <video
            controls
            playsInline
            preload='metadata'
            width={width}
            height={height}
            poster={`${VIDEO_BASE}/so_0/${publicId}.jpg`}
            // Cap the height so portrait clips keep their controls on screen
            className='520:max-w-[500px] max-w-full w-auto h-auto max-h-[80vh]'
        >
            {/* MP4 (H.264) plays in every browser; the originals are QuickTime .mov files */}
            <source src={`${VIDEO_BASE}/q_auto/${publicId}.mp4`} type='video/mp4' />
        </video>
    )
}
